import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'

Vue.use(VueI18n)

const messages = {
  en: { ...en },
  zh: { ...zh }
}

export function getLanguage() {
  const lang = localStorage.getItem('lang')
  if (lang && (lang == 'en' || lang == 'zh')) {
    return lang
  }
  const lang2 = (navigator.language || navigator.browserLanguage).toLowerCase()
  if (Object.keys(messages).includes(lang2)) {
    return lang2
  }
  return 'zh'
}

const i18n = new VueI18n({ locale: getLanguage(), messages })

export default i18n